<template>
  <b-form-group
    horizontal
    label-cols-lg="3"
    label-class="text-sm-right msc-form-label"
    :label="help ? null : label"
    :label-for="id"
    class="msc-form-group"
    :class="fieldClass"
  >
    <template v-if="help" #label>
      <span class="msc-form-label__wrap">
        <span class="msc-form-label__text">{{ label }}</span>
        <help-tip :tip="help" @click="$emit('help-click')" />
      </span>
    </template>
    <b-form-input
      v-if="isMaskedType"
      class="form-control msc-form-control"
      :id="id"
      :ref="iRef"
      type="text"
      inputmode="numeric"
      :value="maskedDisplayValue"
      :style="cstyle"
      @input.native="onMaskedInput"
      :readonly="readonly"
      v-bind="$attrs"
      :required="required"
      :placeholder="resolvedPlaceholder"
    ></b-form-input>
    <b-form-input
      v-else-if="type !== 'date'"
      class="form-control msc-form-control"
      :id="id"
      :ref="iRef"
      :type="type"
      :value="value"
      :style="cstyle"
      @input.native="$emit('input', $event.target.value)"
      :readonly="readonly"
      v-bind="$attrs"
      :required="required"
      :placeholder="placeholder"
    ></b-form-input>
    <b-form-input
      v-else
      class="form-control msc-form-control"
      :id="id"
      :ref="iRef"
      type="date"
      :value="dateToYYYYMMDD(value)"
      :style="cstyle"
      @input.native="$emit('input', $event.target.value)"
      :readonly="readonly"
      v-bind="$attrs"
      :required="required"
      :placeholder="placeholder"
    ></b-form-input>
  </b-form-group>
</template>
<script>
import Moment from 'moment';
import HelpTip from './HelpTip.vue';
import {
  formatCardExpDisplay,
  formatCardExpInput,
  formatDobDisplay,
  formatDobInput,
} from '@/utils/dateFormat';

export default {
  inheritAttrs: false,
  name: 'sf-input',
  components: {
    HelpTip,
  },
  props: {
    id: {
      type: String,
      default: () => 'input-' + Math.random().toString(),
    },
    iRef: { type: String, default: null },
    placeholder: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    label: { type: String, default: '' },
    help: { type: String, default: '' },
    fieldClass: { type: String, default: '' },
    cstyle: { type: String, default: '' },
    value: { type: [String, Number, Date], default: '' },
  },
  computed: {
    isMaskedType() {
      return this.type === 'dob' || this.type === 'card-exp';
    },
    maskedDisplayValue() {
      if (this.type === 'dob') {
        return formatDobDisplay(this.value);
      }

      if (this.type === 'card-exp') {
        return formatCardExpDisplay(this.value);
      }

      return this.value;
    },
    resolvedPlaceholder() {
      if (this.placeholder) {
        return this.placeholder;
      }

      if (this.type === 'dob') {
        return 'mm/dd/yyyy';
      }

      if (this.type === 'card-exp') {
        return 'MM/YY';
      }

      return '';
    },
  },
  methods: {
    dateToYYYYMMDD(d) {
      if (!d) {
        return '';
      }

      const formatted = Moment(d);
      return formatted.isValid() ? formatted.format('YYYY-MM-DD') : '';
    },
    onMaskedInput(event) {
      const raw = event.target.value;
      const formatted = this.type === 'dob'
        ? formatDobInput(raw)
        : formatCardExpInput(raw);

      event.target.value = formatted;
      this.$emit('input', formatted);
    },
  },
};
</script>
